import React, { FC } from 'react';

import { useLoadPixels } from './hooks/useLoadPixels';
import { useRetargetingPixels } from './hooks/useRetargetingPixels';
import { HiddenButton } from './submodules/HiddenButton';
import { Pixel } from './submodules/Pixel';

export const RetargetingPixels: FC = () => {
  const { pixelUrls, handleAllPixelLoaded } = useRetargetingPixels();

  const { currentPixelIndex, handlePixelLoaded, shouldRenderPixel } =
    useLoadPixels({
      pixelUrls,
      handleAllPixelLoaded,
    });

  if (!pixelUrls) return null;

  return (
    <>
      {shouldRenderPixel && (
        <Pixel
          key={pixelUrls[currentPixelIndex]}
          src={pixelUrls[currentPixelIndex]}
          onLoad={handlePixelLoaded}
          onError={handlePixelLoaded}
        />
      )}
      <HiddenButton />
    </>
  );
};
